module.exports = __webpack_public_path__ + "static/general-terms-and-conditions-of-charging-services-PKN-ORLEN-2024-d09cb3f5d0fab8bffe24052c7ffe193a.pdf";